module.exports = __webpack_public_path__ + "static/media/brackets-curly.ab875a6b.svg";